export default "__VITE_ASSET__e3d81343__"